import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=5b712c54&"
import script from "./ContentEditor.vue?vue&type=script&lang=ts&"
export * from "./ContentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ContentEditor.vue?vue&type=style&index=0&id=5b712c54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports